import React, { Component } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import styled from 'styled-components';

const StyledHeaderSpan = styled.span`
  font-weight: bold;
  padding-left: 1rem;
  vertical-align: middle;
  font-size: 1.3rem !important;
`;

const ActionsToolbar = styled.div`
  padding: 0.5rem;
  padding-bottom: 2rem !important;
  padding-left: 0;
`;

const RightButton = styled(Button)`
  float: right;
`

interface Props {
  disabled?: boolean,
  className?: string,
  headerMessage: string,
  buttonMessage?: string,
  rightButtonMessage?: string,
  trigger?: React.ReactNode,
  onConfirm?: () => void,
  onRightButtonClick?: () => void
}

interface State {

}

class FullScreenPageHeader extends Component<Props, State> {

  render(): React.ReactNode {
    const {
      headerMessage,
      className,
      buttonMessage,
      rightButtonMessage,
      onConfirm,
      onRightButtonClick
    } = this.props;

    return (
        <ActionsToolbar className={`page-header ${className}`}>
          {buttonMessage &&
          <Button
              compact
              icon
              labelPosition="left"
              onClick={onConfirm}
          >
            <Icon name="arrow left"/>
            {buttonMessage}
          </Button>
          }
          <StyledHeaderSpan className="title">
            {headerMessage}
          </StyledHeaderSpan>
          {rightButtonMessage &&
          <RightButton
              compact
              icon
              labelPosition="right"
              onClick={onRightButtonClick}
          >
            {rightButtonMessage}
            <Icon name="arrow right"/>
          </RightButton>
          }
        </ActionsToolbar>
    )
  }

}

export default FullScreenPageHeader;
